import { QueryClient } from "@tanstack/react-query";

// Single app-lifetime QueryClient, shared between index.js (provider) and
// store.js (auth middleware). Query keys like 'dashboardCounts' don't carry
// user/clinic/demo identity, so this cache must be wiped on every auth
// transition (login/logout/impersonation) — see store.js's clearQueryCacheOnAuthChange.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,      // 2 min — data considered fresh
      gcTime: 5 * 60 * 1000,          // 5 min — keep in cache after unmount
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const status = error?.response?.status || error?.status;
        // Auth/permission errors won't succeed on retry — retrying just doubles
        // the "no permission" toast for every failing dashboard widget.
        if (status === 401 || status === 403 || status === 404) return false;
        return failureCount < 1;
      },
    },
  },
});
